import { useEffect, useState } from 'react';

const useInView = (
    ref: React.RefObject<Element>,
    quickDetect: boolean = false
) => {
    const [inView, setInView] = useState(false);
    const [boundingClientRect, setBoundingClientRect] =
        useState<DOMRect | null>(null);

    useEffect(() => {
        if (!ref.current) return;

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    setInView(
                        quickDetect
                            ? entry.isIntersecting
                            : entry.isIntersecting &&
                                  entry.intersectionRatio === 1
                    );
                    setBoundingClientRect(entry.boundingClientRect);
                });
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: quickDetect ? 0.1 : 1.0,
            }
        );

        observer.observe(ref.current);

        return () => {
            observer.disconnect();
        };
    }, [ref]);

    return { inView, boundingClientRect };
};

export default useInView;
